import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
} from "@chakra-ui/react";

function LogoutAlertDialog({
  isOpen,
  onOpen,
  callback,
  onClose,
  title,
  heading,
  icon,
  buttonViewContent,
  hideFooter,
}) {
  const closeAlert = () => {
    callback();
    onClose();
  };

  return (
    <>
      <HStack onClick={onOpen}>
        {icon}
        {buttonViewContent}
      </HStack>

      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent margin={2} borderRadius={0}>
            <AlertDialogHeader
              display={"flex"}
              alignItems={"center"}
              fontSize="lg"
              fontWeight="bold"
              columnGap={4}
            >
              {icon} {title}
            </AlertDialogHeader>

            <AlertDialogBody fontSize={"lg"} fontWeight={500}>
              {heading}
            </AlertDialogBody>

            {!hideFooter && (
              <AlertDialogFooter>
                <Button onClick={onClose} variant={"outline"} borderRadius={0}>
                  Cancel
                </Button>
                <Button onClick={closeAlert} ml={3} borderRadius={0}>
                  {title}
                </Button>
              </AlertDialogFooter>
            )}
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export { LogoutAlertDialog };
